import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { API_URL } from '../utils/api';
import { KeyRound } from 'lucide-react';

const API = `${API_URL}/admin`;

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setMessage('');

    try {
      await axios.post(`${API}/password-reset/request`, { email });
      // Always show success message for security - never reveal if email exists
      setMessage('If an account exists with this email, a password reset link has been sent.');
      setTimeout(() => navigate('/admin/login'), 3000);
    } catch (err) {
      // For security, show the same message even on error (don't reveal if email exists)
      // Only show actual error for network/server issues
      if (err.response?.status >= 500 || !err.response) {
        setError('Unable to process request. Please try again later.');
      } else {
        // For any other response (including 404), show success to prevent email enumeration
        setMessage('If an account exists with this email, a password reset link has been sent.');
        setTimeout(() => navigate('/admin/login'), 3000);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login-container">
      <Card className="admin-login-card">
        <CardHeader>
          <div className="admin-login-icon">
            <KeyRound size={48} />
          </div>
          <CardTitle className="admin-login-title">Forgot Password</CardTitle>
          <CardDescription style={{ textAlign: 'center', color: '#8b9a7e', marginTop: '8px' }}>
            Enter your email address and we'll send you a reset link
          </CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="admin-login-form">
            <div className="form-group">
              <Label htmlFor="email" style={{ color: '#c5bfa9' }}>Email</Label>
              <Input
                id="email"
                type="email"
                placeholder="admin@example.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="admin-input"
              />
            </div>

            {message && (
              <div style={{ 
                padding: '12px', 
                borderRadius: '6px', 
                background: 'rgba(90, 111, 78, 0.2)', 
                border: '1px solid #5a6f4e',
                color: '#8b9a7e',
                fontSize: '0.875rem'
              }}>
                {message}
              </div>
            )}

            {error && (
              <div className="admin-login-error">
                {error}
              </div>
            )}

            <Button type="submit" className="admin-login-button" disabled={loading}>
              {loading ? 'Sending...' : 'Send Reset Link'}
            </Button>

            <div style={{ textAlign: 'center' }}>
              <Link 
                to="/admin/login" 
                style={{ 
                  color: '#5a6f4e', 
                  fontSize: '0.875rem', 
                  textDecoration: 'none',
                  fontWeight: '500'
                }}
              >
                Back to Login
              </Link>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};

export default ForgotPassword;
